// extracted by mini-css-extract-plugin
export var btnContainer = "timeline-promo-module--btnContainer--I-1ky";
export var colOne = "timeline-promo-module--colOne--b05An";
export var colTwo = "timeline-promo-module--colTwo--H3rrQ";
export var content = "timeline-promo-module--content--IJpGl";
export var darkTitle = "timeline-promo-module--darkTitle--nqZan";
export var imgContainer = "timeline-promo-module--imgContainer--AhtdY";
export var promoComponent = "timeline-promo-module--promo-component--ucR+n";
export var promoTitle = "timeline-promo-module--promoTitle--9Z7QM";